import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import { MegaMenuTemplateProps } from '../../shared/types';
import { environment } from '../../environments/environment';

export const renderDesktContainer = (props: MegaMenuTemplateProps) => {
  const img = `${environment.assetsUrl}/images/${props.selectedOption?.id}-l.svg`;
  return html`
    <div>
      <h2
        class=${classMap({
          'selected-option': true,
          'selected-option--non-pressable': !props.selectedOption?.pressable,

        })}
      >
        <a
          class="bc-flex  bc-justify-content-space-between  bc-align-items-center"
          href=${props.selectedOption?.pressable ? props.selectedOption.url : '#'}
          @click=${!props.selectedOption?.pressable ? (e: Event) => e.preventDefault() : undefined}
        >
        <img class="title-option" src=${img} />
        ${props.selectedOption?.pressable ?
          html`<i class="bc-icon bc-icon-button">arrow-long-right</i>`
          : nothing}
        </a>
      </h2>

      <ul class="submenu-option-container bc-flex bc-direction-column bc-gap-1">
        ${repeat(
          props.selectedOption?.categories ?? [],
          c => c.title,
          submenuItem =>
            html`<li
              id=${submenuItem.title.replace(/\s+/g, '-').toLowerCase()}
              class=${classMap({
                'submenu-option': true,
                'bc-flex': true,
                'bc-justify-content-space-between': true,
                selected: props.selectedCategory?.title === submenuItem.title
              })}
              role="button"
              tabindex="0"
              aria-label="${submenuItem.title}"
              @click=${() => props.onCategorySelect(submenuItem)}
              @keydown=${(e: KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  props.onCategorySelect(submenuItem);
                }
              }}
            >
              <div class="bc-flex bc-align-items-center bc-gap-2">
                <em class="bc-icon" aria-hidden="true">${submenuItem.icon}</em>
                <a>${submenuItem.title}</a>
              </div>
              ${submenuItem.listOptions?.length
                ? html`<em class="bc-icon" aria-hidden="true">arrow2-right</em>`
                : nothing}
            </li>`
        )}
      </ul>
    </div>
  `;
};
